module.exports = __webpack_public_path__ + "img/corner.4d110405.png";